(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .controller('ExecutiveSummaryCtrl', ExecutiveSummaryCtrl);

  // @ngInject
  function ExecutiveSummaryCtrl(storeKeys, filters, StandardReports, DateUtil, SectionConfig, ExecutiveSummary,
                                ExecSummaryMetric, CalloutLabelService, ShopperAdoptionCallout, UserCohort) {
    var vm = this;

    var detailLevel = filters.pathParams.detailLevel;
    var queryFilters = _.merge(filters.queryParams, {storeKey: storeKeys});

    vm.isLoading = true;

    vm.transactionColorSwatch = ExecutiveSummary.colorSwatches();

    vm.dateRange = {startDate: filters.queryParams.startDate, endDate: filters.queryParams.endDate};

    vm.cards = ExecutiveSummary.cards;

    vm.dataForUserCohort = function (card, label) {
      var data =_.find(card.metricValues, { label: label });
      return card.options.metricValuesFormat(data && data.value);
    };

    _.each(vm.cards, function(card) {
      card.getData = function() {
        return StandardReports.getConsumerData('executive-summary', detailLevel, queryFilters);
      };

      card.chartOptions = ExecutiveSummary.chartOptions();

      card.dataOptions = function(rawData) {
        var metricSummary = _.find(rawData, { metricName: card.key });
        card.change = metricSummary.change;

        card.metricValues = _.map(metricSummary.userCohortValues, function (data) {
          var metricLabel = _.find(card.userCohortValues, function (type) {
            return _.isEqual(type.userCohort.value, data.userCohort);
          });
          return ExecSummaryMetric(metricLabel.label, metricLabel.colorClass, metricLabel.userCohort.value, data.value);
        });

        return ExecutiveSummary.chartDataOptions(card);

      }
    });

    vm.adoptionCallouts = [
      ShopperAdoptionCallout('TFAdoptionCallout.tmpl.html', SectionConfig.adoption.chart.label, 'tf-users-percent'),
      ShopperAdoptionCallout('TFSessionsCallout.tmpl.html', SectionConfig.tfSessionsAdoption.chart.label, 'tf-sessions-percent'),
      ShopperAdoptionCallout('TFRevenueCallout.tmpl.html',  SectionConfig.tfRevenue.chart.label, 'tf-revenue-percent')
    ];

    vm.adoptionCallouts.forEach(function (value) {
      StandardReports.getConsumerData(value.attributeName, detailLevel, queryFilters).then(function (tfPercent) {
        vm[value.attributeName] = StandardReports.findInSummary(tfPercent.summary, 'TFPercent', UserCohort.tf.value);
      });
    });

  }
  })();
